<template>
  <div class="body">
    <div class="body-foot1">
      <div class="body-foot1-logo">
        <img src="~@/assets/images/logo-bai.png" />
      </div>
      <div class="body-foot1-menu">
        <div class="body-foot1-menu-item"
             @click="onRouter('/')">网站首页</div>
        <div class="body-foot1-menu-pd"></div>
        <div class="body-foot1-menu-item"
             @click="onRouter('/about')">走进新恒基</div>
        <div class="body-foot1-menu-pd"></div>
        <div class="body-foot1-menu-item"
             @click="onRouter('/news')">新闻中心</div>
        <div class="body-foot1-menu-pd"></div>
        <div class="body-foot1-menu-item"
             @click="onRouter('/product')">产品与应用</div>
      </div>
    </div>
    <div class="body-line"></div>
    <div class="body-boxs">
      <div class="body-boxs-box">
        <div class="body-boxs-box-label">地址</div>
        <div class="body-boxs-box-content">
          <img src="~@/assets/images/point.png" />
          <div class="body-boxs-box-content-text">
            {{web.name}}<br />
            {{web.address}}
          </div>
        </div>
      </div>
      <div class="body-boxs-pd"></div>
      <div class="body-boxs-box">
        <div class="body-boxs-box-label">联系方式</div>
        <div class="body-boxs-box-content">
          <img src="~@/assets/images/phone-icon.png" />
          <div class="body-boxs-box-content-text">
            联系电话： {{web.tel}}<br />
            联系传真： {{web.fax}}
          </div>
        </div>
      </div>
      <div class="body-boxs-pd"></div>
      <div class="body-boxs-box">
        <div class="body-boxs-box-label">EMAIL</div>
        <div class="body-boxs-box-content">
          <img src="~@/assets/images/email.png" />
          <div class="body-boxs-box-content-text">
            {{web.email}}
          </div>
        </div>
      </div>
    </div>
    <div class="body-bottom"><a href="https://beian.miit.gov.cn/"
         target="_blank"
         class="a_w">{{web.icp}}</a></div>
  </div>
</template>

<script>
import { getWebconfig } from "@/service/index";
export default {
  name: "AppFooter",
  components: {},
  data () {
    return {
      web: [],
    };
  },
  mounted () {
    this.getwebconfig();
  },
  methods: {
    getwebconfig () {
      getWebconfig().then(res => {

        this.web = res.data;
      })
    },
    onRouter (path) {
      this.show = false;
      this.path = path;
      this.$router.push({
        path: `${path}`,
      });
    },

  },
};
</script>
<style scoped lang="scss" src="./index.scss"></style>
